<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import logoImg from '@/assets/logo.png'

const route = useRoute()

// The way to the other page: sign-up from sign-in, and sign-in from everywhere else
const action = computed(() =>
  route.name === 'login'
    ? { text: 'New to China Tour Deal?', label: 'Create an account', to: '/signup', icon: 'fa fa-user-plus' }
    : { text: 'Already registered?', label: 'Sign in', to: '/login', icon: 'fa fa-sign-in-alt' }
)
</script>

<template>
  <header class="guest-header">
    <div class="ui-shell header-content">
      <RouterLink to="/login" class="logo-link" aria-label="China Tour Deal, sign in">
        <img :src="logoImg" alt="China Tour Deal" />
      </RouterLink>

      <!-- A div, not a nav: the app-wide mobile menu styles every "header nav" as a drawer -->
      <div class="guest-nav">
        <span class="guest-text">{{ action.text }}</span>
        <RouterLink :to="action.to" class="ui-btn is-sm guest-btn">
          <i :class="action.icon" aria-hidden="true"></i>{{ action.label }}
        </RouterLink>
      </div>
    </div>
  </header>
</template>

<style scoped>
@import url("./GuestHeader.css");
</style>
